import React from 'react';

class ErrorMessenger extends React.Component {
    constructor(props) {
        super(props);

        if (props.form) {
            this.unregister = props.form.registerErrorMessenger(this);
        }

        this.state = {
            errorMessage: ''
        }
    }

    componentWillUnmount() {
        if (this.unregister) {
            this.unregister();
        }
    }

    notify(error) {
        this.setState({
            errorMessage: error
        });
    }

    clear(){
        this.setState({
            errorMessage: ''
        });
    }

    render () {
        const stateClass = (this.state.errorMessage && this.state.errorMessage.length > 0) ? 'show' : 'hide';
        return (
            <div {...this.props} className={['component-error-messenger', this.props.className, stateClass].join(' ')}>
                {this.state.errorMessage}
            </div>
        )
    }
}

export default ErrorMessenger;



// WEBPACK FOOTER //
// ./web-app/components/error-messenger.jsx